<app-base-modal
  [title]="'Артикула набора продуктов'"
  [modalMaxHeight]="'95vh'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="product-card-group-search-row">
    <mat-form-field
      appearance="outline"
      class="product-card-group-search"
    >
      <mat-label>Поиск</mat-label>
      <input
        #searchInput
        matInput
        [value]="searchTerm()"
        (input)="handleSearch(searchInput.value)"
        (keydown.enter)="handleEnterSearch()"
      >
    </mat-form-field>
  </div>
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    @for (tab of tabsData; track $index) {
      <mat-tab [label]="tab.title">
        @if (!getDataByTab().length) {
          <div class="product-card-group-empty">
            {{ tab.emptyText }}
          </div>
        } @else {
          <app-carousel
            [itemsCount]="getDataByTab().length"
            [gap]="20"
            [visibleItems]="3"
            (currentIndexChange)="handleIndexChange($event)"
          >
            <div class="product-card-group-cards">
              @for (data of getDataByTab(); track $index) {
                <div
                  app-product-card-group-item
                  class="product-card-group-card"
                  [wildberriesProductCardData]="data"
                  [btnKey]="tab.btnKey"
                  [(selectedData)]="selectedData"
                ></div>
              }
            </div>
          </app-carousel>
        }
      </mat-tab>
    }
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="!selectedData().length"
      (click)="handleBtn()"
    >
      {{ selectedTabIndex() === 0 ? 'Отвязать' : 'Привязать' }}
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
